import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface RadioButtonContainerProps
  extends HTMLAttributes<HTMLDivElement>,
    PropsWithChildren {
  checked?: boolean;
}

const RadioButtonContainer = forwardRef<
  HTMLDivElement,
  RadioButtonContainerProps
>(({ children, checked, ...props }, ref) => {
  return (
    <div ref={ref} {...props} className={cn(props.className, 'relative')}>
      {checked && <div className={cn(css.effect, css.effectFirst)}></div>}
      {checked && <div className={cn(css.effect, css.effectSecond)}></div>}
      <div
        className={cn(
          css.offerItem,
          checked && css['offerItem--active'],
          checked && css['offerItem--active'],
        )}
      >
        {checked && <div className={css.elipse}></div>}
        <div
          className={cn(css.checkbox, checked && css['checkbox--active'])}
        ></div>
        {children}
      </div>
    </div>
  );
});

export { RadioButtonContainer, type RadioButtonContainerProps };
